import { render } from "./Sticky.vue?vue&type=template&id=57656a42&scoped=true"
import script from "./Sticky.vue?vue&type=script&lang=js"
export * from "./Sticky.vue?vue&type=script&lang=js"

import "./Sticky.vue?vue&type=style&index=0&id=57656a42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57656a42"]])

export default __exports__